import { Injectable } from "@angular/core";
import { ApiService } from './api.service';
import { NivelInterface } from "../models/nivel.model";

@Injectable({
  providedIn: 'root'
})

export class NivelService extends ApiService<NivelInterface>{
  url="niveles"
}
